export const tablet = "900px";
export const phone = "500px";
